import { v4 as uuid4 } from "uuid"
import { COOKIE_EXPIRE_DAYS, COOKIE_HID_KEY, COOKIE_USER_ID_KEY } from "../config"
import Cookie from "./Cookie"

export default class IdentifierManager {
  static initialize() {
    const id = Cookie.get(COOKIE_HID_KEY)
    if (!id) {
      generateIdentifier()
    }
  }
  static reInitialize() {
    generateIdentifier()
  }
}

export function getUserId(): string {
  const userId = Cookie.get(COOKIE_USER_ID_KEY)
  if (userId) {
    return userId
  }
  const id = Cookie.get(COOKIE_HID_KEY)
  if (id) {
    return id
  } else {
    return generateIdentifier()
  }
}

export function setUserId(userId: string): void {
  Cookie.set(COOKIE_USER_ID_KEY, userId, COOKIE_EXPIRE_DAYS, true)
}

export function removeUserId(): void {
  Cookie.remove(COOKIE_USER_ID_KEY, true)
}

export function generateIdentifier(): string {
  const id = uuid4()
  Cookie.set(COOKIE_HID_KEY, id, COOKIE_EXPIRE_DAYS, true)
  return id
}
